import { FREE_TRIAL_STATUS_PENDING } from "./User";
export const FREE_UNTIL_FIXED_TIMESTAMP = 1696132799;
export const MIN_TRIAL_DAYS = 7;

// noinspection JSUnusedGlobalSymbols
export class FreeTrial {
  constructor() {
    this.end = 0;
    this.hash = '';
    this.note = '';
    this.start = 0;
    this.status = FREE_TRIAL_STATUS_PENDING;
  }

  /**
   * Returns the Unix timestamp (in seconds) if a pending trial were started today
   */
  trialEndUnixTimeSecondsStartingNow() {
    const now = Math.round(Date.now() / 1000);
    let endTime = now + 86400 * MIN_TRIAL_DAYS;

    // it's free until the end of 2023, so it might get extended
    if (FREE_UNTIL_FIXED_TIMESTAMP > endTime) {
      endTime = FREE_UNTIL_FIXED_TIMESTAMP;
    }
    return endTime;
  }
}